<div style="padding: 20px">
    <div class="one-row">
        <h1>
            Externer Untersuchungsauftrag
            {{ untersuchungsauftragId === "neu" ? "erstellen" : untersuchungsauftragId }}
        </h1>
        <button
            *ngIf="untersuchungsauftrag.status_id === 91"
            mat-icon-button
            color="accent"
            matTooltip="Untersuchungsauftrag zwischenspeichern"
            (click)="save(untersuchungsauftrag.status_id)"
        >
            <mat-icon>save_alt</mat-icon>
        </button>
    </div>
    <mat-card>
        <mat-card-content>
            <h3>Allgemein</h3>
            <div class="ua-general">
                <div class="ua-kunde">
                    <kiene-client-group-autocomplete
                        [disabled]="vomBefund() || untersuchungsauftrag.status_id >= 92"
                        [gruppe]="gruppe"
                        [showInactiveToggle]="true"
                        (selectedGroup)="this.gruppe = $event"
                        [focus]="true"
                    >
                    </kiene-client-group-autocomplete>
                </div>

                <mat-form-field>
                    <input type="text" placeholder="Tagebuch-Nr" matInput [formControl]="tagebuchCtrl" />
                </mat-form-field>
                <mat-form-field>
                    <input type="text" placeholder="Kennzeichnung" matInput [formControl]="kennzeichnungCtrl" />
                </mat-form-field>
                <div class="ua-status">
                    <span class="phito-status-badge">{{
                        untersuchungsauftrag.status ? untersuchungsauftrag.status : "Neu"
                    }}</span>
                </div>

                <div class="ua-labor">
                    <kiene-autocomplete
                        [disabled]="vomBefund() || untersuchungsauftrag.status_id >= 92"
                        [apiUrl]="'lieferant/'"
                        [placeholder]="'Labor'"
                        [displayField]="'bezeichnung'"
                        (elementSelected)="setLabor($event)"
                        [kieneObject]="labor"
                    ></kiene-autocomplete>
                </div>
                <mat-form-field>
                    <input
                        matInput
                        [matDatepicker]="picker"
                        placeholder="Probenentnahme"
                        [formControl]="probenentnahmeCtrl"
                    />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <div class="ua-contact">
                    <span class="ua-contact-label">Ansprechpartner</span>
                    <span>{{
                        untersuchungsauftrag.ansprechpartner
                            ? untersuchungsauftrag.ansprechpartner
                            : untersuchungsauftrag.tierarzt_id
                              ? untersuchungsauftrag.tierarzt
                              : kieneSession.vorname + " " + kieneSession.nachname
                    }}</span>
                </div>
            </div>
            <div class="ua-links">
                <div *ngIf="untersuchungsauftrag.formular_dateiname || untersuchungsauftrag.lieferant_dokument_id">
                    <button mat-stroked-button type="button" color="primary" (click)="openFormular(formularTpl)">
                        <mat-icon>picture_as_pdf</mat-icon>
                        Formular
                    </button>
                </div>
                <div *ngIf="untersuchungsauftrag.status_id === 92 && untersuchungsauftrag.pdf_id">
                    <button mat-stroked-button type="button" color="primary" (click)="showFertigePdf()">
                        <mat-icon>picture_as_pdf</mat-icon>
                        Fertige PDF
                    </button>
                </div>
                <div *ngIf="untersuchungsauftrag.bestellung_extern_id">
                    Bestellung:
                    <a href="javascript:void(0)" (click)="goToBestellung()">{{
                        untersuchungsauftrag.bestellung_extern_id
                    }}</a>
                    (offen / Preise folgen mit Lab-RE)
                </div>
                <div *ngIf="untersuchungsauftrag.befund_id">
                    Befund:
                    <a href="javascript:void(0)" (click)="goToBefund()">{{ untersuchungsauftrag.befund_id }}</a>
                </div>
            </div>

            <ng-template #formularTpl>
            <h2 mat-dialog-title>Formular ausfüllen</h2>
            <mat-dialog-content>
            <div *ngIf="fillOverlays.length" class="ua-pdf-fill">
                <div class="ua-pdf-head">
                    <h4>Direkt auf dem Formular</h4>
                    <span class="ua-legend edit">hier schreiben</span>
                    <span class="ua-legend context">wird aus dem Auftrag gefüllt</span>
                    <span class="spacer"></span>
                    <button mat-icon-button type="button" (click)="prevFillPage()" [disabled]="fillPage <= 1">
                        <mat-icon>navigate_before</mat-icon>
                    </button>
                    <span>Seite {{ fillPage }} / {{ fillPageCount }}</span>
                    <button
                        mat-icon-button
                        type="button"
                        (click)="nextFillPage()"
                        [disabled]="fillPage >= fillPageCount"
                    >
                        <mat-icon>navigate_next</mat-icon>
                    </button>
                </div>
                <div #pdfHost class="ua-pdf-host">
                    <div *ngIf="fillPdfLoading" class="ua-pdf-hint">PDF wird geladen …</div>
                    <div *ngIf="!fillPdfLoading && fillPdfError" class="ua-pdf-hint err">{{ fillPdfError }}</div>
                    <div class="ua-pdf-stage" *ngIf="fillPdfSrc">
                    <pdf-viewer
                        [src]="fillPdfSrc"
                        [page]="fillPage"
                        [show-all]="false"
                        [render-text]="false"
                        [original-size]="false"
                        [fit-to-page]="false"
                        [autoresize]="true"
                        [zoom-scale]="'page-width'"
                        (after-load-complete)="onFillPdfLoad($event)"
                        (page-rendered)="placeFillMarks()"
                    ></pdf-viewer>
                    <div class="ua-pdf-marks" [attr.data-tick]="fillLayoutTick">
                        <ng-container *ngFor="let m of overlaysOnFillPage()">
                            <textarea
                                *ngIf="isFillTextBlock(m)"
                                class="ua-pdf-block"
                                [ngStyle]="fillBlockStyle(m)"
                                [(ngModel)]="formularWerte[m.placeholder]"
                                [disabled]="formularGesperrt()"
                                [attr.placeholder]="m.label"
                                [title]="m.label"
                            ></textarea>
                            <input
                                *ngIf="m.kind === 'text' && !isFillTextBlock(m)"
                                class="ua-pdf-input"
                                [ngStyle]="fillLineStyle(m)"
                                [(ngModel)]="formularWerte[m.placeholder]"
                                [disabled]="formularGesperrt()"
                                [attr.placeholder]="m.label"
                                [title]="m.label"
                            />
                            <button
                                *ngIf="m.kind === 'checkbox'"
                                type="button"
                                class="ua-pdf-check"
                                [class.on]="formularWerte[m.placeholder] === '1'"
                                [ngStyle]="fillMarkerStyle(m)"
                                [disabled]="formularGesperrt()"
                                [title]="m.label"
                                (click)="toggleFormularCheckbox(m.placeholder)"
                            >
                                {{ formularWerte[m.placeholder] === '1' ? 'X' : '' }}
                            </button>
                            <span
                                *ngIf="m.kind === 'context'"
                                class="ua-pdf-context"
                                [ngStyle]="fillMarkerStyle(m)"
                                [title]="m.label"
                                >{{ m.label }}</span
                            >
                        </ng-container>
                    </div>
                    </div>
                </div>
            </div>
            <p *ngIf="!fillOverlays.length" class="ua-formular-leer">Kein gemapptes Formular.</p>
            </mat-dialog-content>
            <mat-dialog-actions align="end">
                <button mat-button type="button" mat-dialog-close>Schließen</button>
            </mat-dialog-actions>
            </ng-template>

            <div *ngIf="formularFelderOhneOverlay().length" class="ua-formular">
                <h4>Formularfelder</h4>
                <div class="ua-formular-grid">
                    <ng-container *ngFor="let f of formularFelderOhneOverlay()">
                        <mat-form-field *ngIf="f.type === 'checkbox'">
                            <mat-label>{{ f.label }}</mat-label>
                            <mat-select
                                [(ngModel)]="formularWerte[f.key]"
                                [disabled]="untersuchungsauftrag.status_id >= 92"
                            >
                                <mat-option value="">— wählen —</mat-option>
                                <mat-option value="1">Ja (X)</mat-option>
                                <mat-option value="0">Nein (leer)</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field *ngIf="f.type !== 'checkbox'">
                            <mat-label>{{ f.label }}</mat-label>
                            <input
                                matInput
                                [(ngModel)]="formularWerte[f.key]"
                                [disabled]="untersuchungsauftrag.status_id >= 92"
                            />
                        </mat-form-field>
                    </ng-container>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <div style="margin-top: 10px">
        <mat-chip-list>
            <mat-chip
                style="cursor: pointer"
                *ngFor="let ud of untersuchungsauftragDokumente"
                [removable]="true"
                [selectable]="true"
                (removed)="removeUntersuchungsauftragDokument(ud)"
                (click)="untersuchungsauftragDokumentSelected(ud)"
                >{{ ud.dateiname }}<mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
        </mat-chip-list>
    </div>

    <mat-card
        *ngIf="!vomBefund() && untersuchungsauftrag.status_id < 92 && labor !== undefined && labor !== null"
        style="margin-top: 20px"
    >
        <mat-card-content>
            <h3>Position hinzufügen</h3>

            <form>
                <div class="one-row" style="width: fit-content">
                    <div style="width: 300px; margin-right: 15px">
                        <kiene-autocomplete
                            [apiUrl]="'artikel_autocomplete/'"
                            [params]="params"
                            [placeholder]="'Artikel'"
                            [displayField]="'artikel_me'"
                            (elementSelected)="setArtikel($event)"
                            [kieneObject]="selectedArtikel"
                        ></kiene-autocomplete>
                    </div>
                    <div style="width: 100px; margin-right: 15px">
                        <mat-form-field style="width: 100%">
                            <input matInput type="number" placeholder="Anzahl" [formControl]="anzahlCtrl" />
                        </mat-form-field>
                    </div>
                    <div style="width: 400px; margin-right: 15px">
                        <mat-form-field style="width: 100%">
                            <input
                                matInput
                                type="string"
                                placeholder="Notiz"
                                [formControl]="notizCtrl"
                                (keydown)="checkEnterKey($event)"
                            />
                        </mat-form-field>
                    </div>

                    <div>
                        <button mat-mini-fab type="submit" (click)="addCurrentPosition()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>

                    <span class="spacer"></span>
                </div>
            </form>
        </mat-card-content>
    </mat-card>

    <h4 style="padding-left: 20px">Positionen</h4>
    <table class="phito-table" style="margin-top: 20px; margin-left: 20px">
        <thead>
            <tr>
                <th>Pos.</th>
                <th>Artikel</th>
                <th>Anzahl</th>
                <th>Notiz</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let p of positionen; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ p.artikel }}</td>
                <td>{{ p.anzahl }}</td>
                <td>{{ p.notiz }}</td>
                <td>
                    <button
                        *ngIf="!vomBefund() && untersuchungsauftrag.status_id < 92"
                        class="delete-button"
                        mat-icon-button
                        (click)="removePosition(p)"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
    <div
        *ngIf="untersuchungsauftrag.status_id === 91 || untersuchungsauftrag.status_id === 92"
        style="width: 100%; text-align: right; margin-top: 20px"
    >
        <span *ngIf="untersuchungsauftrag.status_id === 92" [matTooltip]="wiederOeffnenHinweis()">
            <button
                mat-stroked-button
                type="button"
                (click)="reopen()"
                [disabled]="!kannWiederOeffnen()"
            >
                Wieder öffnen
            </button>
        </span>
        <button
            *ngIf="untersuchungsauftrag.status_id === 91"
            mat-flat-button
            (click)="close()"
            color="accent"
            matTooltip="Speichert den Auftrag, setzt ihn auf abgeschlossen und öffnet das ausgefüllte Labor-PDF zum Versand."
        >
            Abschließen
        </button>
    </div>
</div>
